import React from "react";
import { toPrice } from "../../../../helpers/stringFormat";
import Typography from "@mui/material/Typography";

const TeamPermissionField = ({ limitValue }) => {
  let displayText = toPrice(limitValue);
  let sx = {
    height: "100%",
  };
  let color = null;

  if (limitValue == -1) {
    color = "secondary";
    sx.fontStyle = "italic";
    displayText = "Unlimited";
  }
  return (
    <Typography
      sx={sx}
      color={color}
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      {displayText}
    </Typography>
  );
};

export default TeamPermissionField;
